import React from 'react'

import LogoSVG from '../assets/logo/logo.svg'

const Logo = props => {
  return <LogoSVG {...props} style={{ display: 'block' }} />
}

export default Logo
